var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-body"},[[_c(_vm.getComponentName,{tag:"component",staticClass:"wrapper",attrs:{"compProps":_vm.getComponentName,"customUrl":_vm.customUrl,"pageTitle":_vm.pageTitle},on:{"navHome":_vm.navHome}})]],2)}
var staticRenderFns = []

export { render, staticRenderFns }